import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { EmpresaService } from '../../../../services/Empresa/Empresa.service';
import { PedidosService } from '../../../../services/pedidos/pedidos.service';

@Component({
  selector: 'app-modal-guia',
  templateUrl: './modal-guia.component.html',
  styleUrls: ['./modal-guia.component.scss'],
})
export class ModalPedidoGuiaComponent implements OnInit {
  public formGroup = this.formBuilder.group({
    IdEstatus: [null, [Validators.required]],
    Obervaciones: '',
  });
  public detalleArticulos$: Observable<any>;
  empresaId: number;
  guiaSeleccionada: any;

  public selection: SelectionModel<any> = new SelectionModel<any>(true, []);
  selectedIndex = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public matDialogRef: MatDialogRef<ModalPedidoGuiaComponent>,
    private pedidosService: PedidosService,
    private empresaService: EmpresaService
  ) 
  { }

  ngOnInit() {
    console.log(this.data);
    this.empresaId = this.empresaService.getEmpresaId();
    const tpPedido = this.data.pedido.TipoPedido === 'Cedis' ? 1 : 0;
    this.detalleArticulos$ = this.pedidosService.getDetalleArticulos(
      this.data.pedido.AlmacenId,
      this.data.pedido.PedidoId,
      this.data.pedido.Cliente,
      tpPedido
    );
  }

  modalClose = () => {
    this.data.reload = false;
    this.matDialogRef.close(this.data);
  };
  close = (event) => {
    console.log('event', event);
    if (event) {
      this.data.reload = true;
      this.matDialogRef.close(this.data);
    }
  };

  patchValue = (data: any) => {
    this.formGroup.patchValue({
      IdEstatus: data.estatus[0].EstatusId,
    });
  };

  imprimirDatos = () => {
    const styles = `
      <style>
        body {
          font-family: 'Arial', sans-serif;
          margin: 20px;
          display: grid;
          grid-template-columns: 1fr 2fr;
          column-gap: 10px;
        }
      </style>
    `;

    const w = window.open();
    w.document.write(styles + document.getElementsByClassName('datosEnvio')[0].innerHTML);
    w.print();
    w.close();
  };

  selected(event?: any, row?: any) {
    if (event.checked) {
      this.guiaSeleccionada = row;
    } else {
      this.guiaSeleccionada = null;
    }
    event = event ? this.selection.toggle(row) : null;
    return event;
  }

  deleteSelected = () => {
    console.log(this.selection.selected);
    console.log(this.guiaSeleccionada);
    /* this.selection.selected.forEach((guia) => {
      this.pedidosService.deleteGuia(guia.GuiaId).subscribe((res) => {
        if (res.message === 'true') {
          this.selection.deselect(guia);
        }
      });
    }); */
    Swal.fire({
      type: 'warning',
      title: '¿Está seguro de eliminar la guia seleccionada?',
      text: 'Esta operación no se puede revertir, ¿desea continuar?',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#D33',
      focusConfirm: false,
      focusCancel: true,
      reverseButtons: true
    }).then((res) => {
      if (res.value) {
        console.log('borrar');
        /* this.pedidosService.deleteGuia(this.guiaSeleccionada.GuiaId).pipe(
          takeUntil(this.unsubscribe$),
          catchError((err) => {
          // this.spinner.hide('spinner');
          return this.handleError(err);

          })
        ).subscribe(response=>{
          if (response.data >=1){
             this.getClienteCondicionados();
          } else{
            Swal.fire(
              'Clientes condicionados',
              'Lo sentimos, ocurrio un error al borrar los elementos seleccionados.<br/>',
              'error'
            );
          }
        }); */
      }
    });
  }

  selectTab(index: number): void {
    this.selectedIndex = index;
  }

  // onSubmit = () => {
  //   if (this.formGroup.invalid) {
  //     return;
  //   }
  //   this.insert();
  // }

  // insert = () => {
  //   Swal.fire({
  //     title: 'Actualizando...',
  //     text: 'Por favor espere',
  //     allowOutsideClick: false
  //   });
  //   Swal.showLoading();
  //   let observaciones: string = this.eliminarAcentos(this.formGroup.value.Obervaciones);
  //   this.pedidosService.insert(
  //     this.data.pedido.estatus[0].IdPedidoEstatus,
  //     this.data.pedido.IdWsPedido,
  //     this.data.pedido.AlmacenId,
  //     this.data.pedido.PedidoId,
  //     this.formGroup.value.IdEstatus,
  //     observaciones.trim()).subscribe((res) => {
  //     if (res.message === 'true') {
  //       Swal.fire({
  //         type: 'success',
  //         title: 'Correcto',
  //         text: res.response,
  //         footer: 'Excelente',
  //         allowOutsideClick: false,
  //         confirmButtonText: 'Aceptar'
  //       }).then((res) => {
  //         if (res.value) {
  //           this.matDialogRef.close(this.data);
  //         }
  //       });
  //     } else {
  //       Swal.fire({
  //         type: 'info',
  //         text: res.response,
  //         allowOutsideClick: false,
  //         confirmButtonText: 'Aceptar'
  //       });
  //     }
  //   },
  //   (error) => {
  //     Swal.fire({
  //       type: 'error',
  //       title: 'Error',
  //       text: error.message,
  //       footer: 'Comunícate para resolver el problema'
  //     });
  //   });
  // }

  // public observacionesLength = (observaciones: string): string => {

  // }

  public eliminarAcentos = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };
}
